/**
 * components/dashboard/JournalAnalyticsView.tsx
 * Full-width "Journal & Analytics" tab — Journal as a left column (a trade
 * list doesn't need much width), Analytics filling the rest (it's the
 * data-heavy one: a sortable scan log with full per-ticker score/diagnostic
 * detail, which was cramped in the old ~288px RightPanel sidebar).
 *
 * Below the lg breakpoint there isn't room for both side by side, so a
 * Journal / Analytics switcher shows one pane at a time instead.
 */

import { useState } from 'react';
import clsx from 'clsx';
import { JournalPanel }   from '../journal/JournalPanel';
import { AnalyticsPanel } from '../analytics/AnalyticsPanel';

export function JournalAnalyticsView() {
  const [pane, setPane] = useState<'journal' | 'analytics'>('journal');

  return (
    <div className="flex flex-col lg:flex-row flex-1 overflow-hidden min-h-0">
      <div className="lg:hidden flex border-b border-border bg-bg-1 flex-shrink-0">
        {(['journal', 'analytics'] as const).map(p => (
          <button
            key={p}
            onClick={() => setPane(p)}
            className={clsx('tab-btn py-3 capitalize', pane === p && 'active')}
          >
            {p}
          </button>
        ))}
      </div>

      <aside className={clsx(
        pane === 'journal' ? 'flex' : 'hidden',
        'lg:flex flex-col flex-1 lg:flex-none w-full lg:w-80 min-h-0 bg-bg-1 lg:border-r border-border overflow-hidden'
      )}>
        <JournalPanel />
      </aside>
      <main className={clsx(
        pane === 'analytics' ? 'flex' : 'hidden',
        'lg:flex flex-col flex-1 min-w-0 min-h-0 overflow-hidden'
      )}>
        <AnalyticsPanel />
      </main>
    </div>
  );
}
